/**
 * GraphQL service
 *
 * @version
 * 4.71.0 OAUI-684 Improve shared code and add interfaces
 * 4.37.0 OAUI-527 Slowdowns in order modals
 * 4.36.0 OAUI-506 Edit order job
 * 4.36.0 OAUI-502 Edit order details
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2022-2024 Build Centrix
 */
import { Inject, Injectable } from '@angular/core';
import { WdLocalSharedFunctionsService } from '../shared/wd-local-shared-functions.service';

@Injectable({
  providedIn: 'root',
})
export class WdGraphQlService {
  /**
   * Constructor Initialization
   * @since 4.36.0
   * @memberof WdGraphQlService
   */
  constructor(
    private wdLocalSharedFunctions: WdLocalSharedFunctionsService,
    @Inject('wdErrorService') public wdErrorService: any,
    @Inject('wdOauth2HttpService') public wdOauth2HttpService: any,
  ) {}

  /**
   * Get GraphQL Data from the Public API
   *
   * @since 4.36.0
   * @memberof WdGraphQlService
   */
  async fetchGraphQlData(query: object): Promise<any> {
    try {
      // Set path and response
      const path = 'graphql';
      const responseFormat = '?responseFormat=bcxResult';

      // Return requested data
      const response = await this.wdOauth2HttpService.post(
        `${this.wdLocalSharedFunctions.publicApiUrl}${path}${responseFormat}`,
        query,
      );

      return response.data;
    } catch (error) {
      return null;
    }
  }
}
